import { styled } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';

const TicketAdvancedLayout = styled(Paper)({
    height: `calc(100% - 48px)`,
    width: "100%",
    maxWidth: "100%",
    display: "grid",
    gridTemplateRows: "1fr",
    overflowX: "hidden",
    overscrollBehaviorX: "none",
    boxSizing: "border-box",
})

export default TicketAdvancedLayout;